<div class="modal-notes">
  <div class="modal-notes-container">
    <div class="modal-notes-title">
      <div class="modal-notes-title-text">Notes</div>
      <button class="modal-close" (click)="activeModal.close()" title="Cancel">
        <rkt-icon name="times"></rkt-icon>
      </button>
    </div>

    @if (notes$ | async; as notes) {
      <div class="note-list">
        <ng-scrollbar track="vertical" class="notes-scroll-wrapper" #scrollRef>
          <div class="d-flex flex-column">
            @if (!notes.length && !newNoteLoading) {
              <div class="notes-empty-message">There are no notes.</div>
            }
            @if (newNoteLoading) {
              <ng-container *ngTemplateOutlet="noteItemPlaceholder"></ng-container>
            }
            @for (note of notes; track note) {
              <app-note-item class="note-list-item" [note]="note" (changed)="refetchNotes()"></app-note-item>
            }
          </div>
        </ng-scrollbar>
      </div>
    } @else {
      <div class="notes-empty-placeholder">
        @for (i of [].constructor(3); track i) {
          <div class="mb-5">
            <ng-container *ngTemplateOutlet="noteItemPlaceholder"></ng-container>
          </div>
        }
      </div>
    }

    <app-add-note
      (addBtnClick)="onNoteAdd($event)"
      [notesLoading]="newNoteLoading"
      [isDisabled]="!!(!(notes$ | async)?.length && loading && !newNoteLoading | accessControl | async)"
      [error]="noteAddError"
    ></app-add-note>
  </div>
</div>

<ng-template #noteItemPlaceholder>
  <app-text-with-placeholder class="notes-placeholder-item" [class.loading]="true" [showPlaceholder]="true"></app-text-with-placeholder>
</ng-template>
